import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=06b51696&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"
import style0 from "./Success.vue?vue&type=style&index=0&id=06b51696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b51696",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VFlex,VIcon,VLayout})
